
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const PkdAtexPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-800 via-red-700 to-red-900 text-white py-24 mt-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/10 rounded-full mb-6">
              <i className="ri-shield-flash-line text-4xl"></i>
            </div>
            <h1 className="text-5xl font-bold mb-6">PKD ve ATEX Çözümleri</h1>
            <p className="text-xl text-red-100 leading-relaxed">
              Patlayıcı ortamlarda güvenli çalışma için profesyonel PKD ve ATEX danışmanlık hizmetleri
            </p>
          </div>
        </div>
      </section>

      {/* PKD ve ATEX Kartları */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* PKD Kartı */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 flex flex-col h-full">
              <div className="flex items-center justify-center w-16 h-16 bg-red-100 rounded-lg mb-6 mx-auto">
                <i className="ri-file-list-3-line text-red-600 text-2xl w-12 h-12 flex items-center justify-center"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">PKD İçeriği</h3>
              <ul className="space-y-4 flex-grow">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Patlayıcı ortam oluşma olasılığının belirlenmesi</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Bölge sınıflandırması (Zone 0-2 veya Zone 20-22)</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Tutuşma kaynaklarının tespiti</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">Risk değerlendirmesi ve önleyici tedbirler</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700">ATEX uyumlu ekipman seçimi</span>
                </li>
              </ul>
            </div>

            {/* ATEX Kartı */}
            <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 flex flex-col h-full">
              <div className="flex items-center justify-center w-16 h-16 bg-red-100 rounded-lg mb-6 mx-auto">
                <i className="ri-shield-check-line text-red-600 text-2xl w-12 h-12 flex items-center justify-center"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">ATEX Direktifleri</h3>
              <ul className="space-y-4 flex-grow">
                <li className="flex items-start">
                  <i className="ri-shield-fill text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <div>
                    <strong className="text-gray-900 block mb-1">ATEX 2014/34/EU</strong>
                    <span className="text-gray-700 text-sm">Ekipman Direktifi - Patlayıcı ortamlarda kullanılacak ekipmanların tasarım ve imalat gereklilikleri</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-shield-fill text-red-600 mt-1 mr-3 flex-shrink-0"></i>
                  <div>
                    <strong className="text-gray-900 block mb-1">ATEX 1999/92/EC</strong>
                    <span className="text-gray-700 text-sm">İşyeri Direktifi - Patlayıcı ortamlarda çalışan işçilerin korunması için minimum önlemler</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Hizmet Süreci */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Hizmet Süreci</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Profesyonel ekibimizle adım adım güvenli çalışma ortamı oluşturuyoruz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
                <span className="text-2xl font-bold text-red-600">1</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Saha İncelemesi ve Veri Toplama</h4>
              <p className="text-gray-600 text-sm">İşyeri detaylı incelenir, süreçler analiz edilir</p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
                <span className="text-2xl font-bold text-red-600">2</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Patlama Riski Analizi</h4>
              <p className="text-gray-600 text-sm">Patlayıcı ortam oluşma olasılıkları değerlendirilir</p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
                <span className="text-2xl font-bold text-red-600">3</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">PKD Hazırlama</h4>
              <p className="text-gray-600 text-sm">Detaylı patlama korunma dokümanı oluşturulur</p>
            </div>

            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
                <span className="text-2xl font-bold text-red-600">4</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Eğitim ve Takip</h4>
              <p className="text-gray-600 text-sm">Personel eğitimi ve periyodik kontroller yapılır</p>
            </div>
          </div>
        </div>
      </section>

      {/* Neden ASSA OSGB */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Neden ASSA OSGB?</h2>
              <p className="text-xl text-gray-600">PKD ve ATEX konusunda uzman kadromuzla yanınızdayız</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start">
                  <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-user-star-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Uzman Kadro</h3>
                    <p className="text-gray-600 text-sm">ATEX ve PKD konusunda sertifikalı ve deneyimli mühendisler</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start">
                  <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-file-text-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Detaylı Dokümantasyon</h3>
                    <p className="text-gray-600 text-sm">Yasal gerekliliklere uygun, eksiksiz PKD hazırlama</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start">
                  <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-tools-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Ekipman Danışmanlığı</h3>
                    <p className="text-gray-600 text-sm">ATEX uyumlu ekipman seçimi ve tedarik desteği</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start">
                  <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-customer-service-2-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Sürekli Destek</h3>
                    <p className="text-gray-600 text-sm">Periyodik kontroller ve güncellemeler için sürekli destek</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-red-800 to-red-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">PKD ve ATEX Danışmanlığı İçin Bize Ulaşın</h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Patlayıcı ortamlarda güvenli çalışma için profesyonel destek alın
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:08503462772"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-red-800 rounded-lg font-semibold hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              0850 346 2772
            </a>
            <a
              href="mailto:assa@assaisg.com"
              className="inline-flex items-center justify-center px-8 py-4 bg-red-700 text-white rounded-lg font-semibold hover:bg-red-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              E-posta Gönder
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PkdAtexPage;
